export default "__VITE_ASSET__BLGnuoul__"